import { render, staticRenderFns } from "./AutorizarAsociacion.vue?vue&type=template&id=97c93b46&"
import script from "./AutorizarAsociacion.vue?vue&type=script&lang=js&"
export * from "./AutorizarAsociacion.vue?vue&type=script&lang=js&"
import style0 from "./AutorizarAsociacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports